import React, { Component } from 'react';
import authService from '../api-authorization/AuthorizeService'
import { FormattedMessage } from 'react-intl';
import { EditButton } from '../controls/EditButton';
import { CreateButton } from '../controls/CreateButton';
import toLocalString from '../infrastructure/DateTimeFunctions';
import { ConfirmAlert } from '../controls/ConfirmAlert'
import { AuthorityModules, AuthorityActions } from '../api-authorization/ApiAuthorizationConstants';

export class Products extends Component {
    static displayName = Products.name;

    constructor(props) {
        super(props);
        this.state = { products: [], loading: true, deleteId: null, confirmOpen: false, isAllowDelete:false };
        this.handleDelete = this.handleDelete.bind(this);
        this.onConfirmClose = this.onConfirmClose.bind(this);
        this.deletedConfirm = this.deletedConfirm.bind(this);
    }

    async componentDidMount() {
        this.populateListData();
        const isAllow = await authService.isAllow(AuthorityModules.Product, AuthorityActions.Delete);
        this.setState({
            isAllowDelete: isAllow
        });
    }
    deletedConfirm(id, e) {
        e.preventDefault();
        this.setState({ confirmOpen: true, deleteId: id });
    }

    onConfirmClose() {
        this.setState({ confirmOpen: false, deleteId: null });
    }
    async handleDelete(e) {
        const id = this.state.deleteId;
        if (!id) { return; }
        this.setState(
            {
                products: this.state.products.filter((rec) => {
                    return (rec.id != id);
                })
            });
        const token = await authService.getAccessToken();
        fetch('product/Delete/' + id, {
            method: 'DELETE',
            headers: !token ? { 'Content-Type': 'application/json' } : { 'Content-Type': 'application/json', 'Authorization': `${token}` }
        }).then(data => {

        });
        this.onConfirmClose();
    }

    static renderTable(products, handleEdit, handleDelete, handleEditActions,isAllowDelete) {
        return (<div className="w-full overflow-x-auto">
            <table className='w-full'>
                <thead>
                    <tr className="text-xs font-semibold tracking-wide text-left text-gray-500 uppercase border-b dark:border-gray-700 bg-gray-50 dark:text-gray-400 dark:bg-gray-800">
                        <th className="px-4 py-3"><FormattedMessage id="Name" /></th>
                     {/*   <th className="px-4 py-3"><FormattedMessage id="Description" /></th>*/}
                        <th className="px-4 py-3">Logo</th>
                        <th className="px-4 py-3"><FormattedMessage id="ModifyTime" /></th>
                        <th className="px-4 py-3"><FormattedMessage id="Actions" /></th>                        
                    </tr>
                </thead>
                <tbody className="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800">
                    {products.map(a =>
                        <tr key={a.id} className="bg-gra-50 hover:bg-gray-100 text-gray-700 dark:text-gray-400 text-sm">
                            <td className="px-4 py-3"><p className="font-semibold">{a.name}</p></td>
                            {/*   <td className="px-4 py-3">{a.description}</td>*/}
                            <td className="px-4 py-3">{a.logoUrl && <img className="" style={{ maxHeight: 30, maxWidth:150 }} src={a.logoUrl} />}</td>
                            <td className="px-4 py-3">{toLocalString(a.modifyTime)}</td>
                            <td className="px-4 py-3 whitespace-nowrap text-sm font-medium">
                                <EditButton module={AuthorityModules.Product} action={AuthorityActions.Edit} url={'/product/EditProduct/' + a.id} />
                                {isAllowDelete && <span>|<a className="text-indigo-600 hover:text-indigo-900" href="#" onClick={(e) => handleDelete(a.id, e)}><FormattedMessage id="delete" /></a></span>}
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
        );
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : Products.renderTable(this.state.products, this.handleEdit, this.deletedConfirm, this.handleEditActions, this.state.isAllowDelete);

        return (
            <div className="mt-4 mx-4">
                <div className="w-full overflow-hidden rounded-lg shadow-xs  mb-2">
                    <div className="flex justify-end items-end">
                        <CreateButton module={AuthorityModules.Product} action={AuthorityActions.Create} url="/product/CreateProduct" />
                    </div>
                </div>
                <div className="w-full overflow-hidden rounded-lg shadow-xs">
                    {contents}
                    <div className="grid px-4 py-3 text-xs font-semibold tracking-wide text-gray-500 uppercase border-t dark:border-gray-700 bg-gray-50 sm:grid-cols-9 dark:text-gray-400 dark:bg-gray-800">
                        <span><FormattedMessage id="RecordCount" /> {this.state.products.length}</span>
                    </div>
                </div>
                <ConfirmAlert onRef={(ref) => { this.confirmRef = ref }} onCancel={this.onConfirmClose} onOk={(id, e) => { this.handleDelete(id, e) }} open={this.state.confirmOpen} />
            </div>
        );
    }



    async populateListData() {
        const token = await authService.getAccessToken();
        const response = await fetch('product/GetProducts', {
            headers: !token ? {} : { 'Authorization': `${token}` }
        });
        const data = await response.json();
        this.setState({ products: data, loading: false });
    }
}
